/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MultiTenantSessionDto } from './MultiTenantSessionDto';
import {
    MultiTenantSessionDtoFromJSON,
    MultiTenantSessionDtoFromJSONTyped,
    MultiTenantSessionDtoToJSON,
    MultiTenantSessionDtoToJSONTyped,
} from './MultiTenantSessionDto';
import type { TimezoneMetadata } from './TimezoneMetadata';
import {
    TimezoneMetadataFromJSON,
    TimezoneMetadataFromJSONTyped,
    TimezoneMetadataToJSON,
    TimezoneMetadataToJSONTyped,
} from './TimezoneMetadata';

/**
 * 
 * @export
 * @interface SessionResponse
 */
export interface SessionResponse {
    /**
     * 
     * @type {string}
     * @memberof SessionResponse
     */
    userTimezone?: string;
    /**
     * Indicates if the request was successful
     * @type {boolean}
     * @memberof SessionResponse
     */
    success?: boolean;
    /**
     * Error message if the request failed
     * @type {string}
     * @memberof SessionResponse
     */
    error?: string;
    /**
     * 
     * @type {TimezoneMetadata}
     * @memberof SessionResponse
     */
    timezoneMetadata?: TimezoneMetadata;
    /**
     * 
     * @type {MultiTenantSessionDto}
     * @memberof SessionResponse
     */
    data?: MultiTenantSessionDto;
    /**
     * 
     * @type {string}
     * @memberof SessionResponse
     */
    errorCode?: string;
    /**
     * 
     * @type {string}
     * @memberof SessionResponse
     */
    message?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SessionResponse
     */
    retryable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SessionResponse
     */
    recommendedAction?: string;
    /**
     * 
     * @type {string}
     * @memberof SessionResponse
     */
    correlationId?: string;
}

/**
 * Check if a given object implements the SessionResponse interface.
 */
export function instanceOfSessionResponse(value: object): value is SessionResponse {
    return true;
}

export function SessionResponseFromJSON(json: any): SessionResponse {
    return SessionResponseFromJSONTyped(json, false);
}

export function SessionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SessionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'userTimezone': json['userTimezone'] == null ? undefined : json['userTimezone'],
        'success': json['success'] == null ? undefined : json['success'],
        'error': json['error'] == null ? undefined : json['error'],
        'timezoneMetadata': json['timezone_metadata'] == null ? undefined : TimezoneMetadataFromJSON(json['timezone_metadata']),
        'data': json['data'] == null ? undefined : MultiTenantSessionDtoFromJSON(json['data']),
        'errorCode': json['errorCode'] == null ? undefined : json['errorCode'],
        'message': json['message'] == null ? undefined : json['message'],
        'retryable': json['retryable'] == null ? undefined : json['retryable'],
        'recommendedAction': json['recommendedAction'] == null ? undefined : json['recommendedAction'],
        'correlationId': json['correlationId'] == null ? undefined : json['correlationId'],
    };
}

export function SessionResponseToJSON(json: any): SessionResponse {
    return SessionResponseToJSONTyped(json, false);
}

export function SessionResponseToJSONTyped(value?: SessionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userTimezone': value['userTimezone'],
        'success': value['success'],
        'error': value['error'],
        'timezone_metadata': TimezoneMetadataToJSON(value['timezoneMetadata']),
        'data': MultiTenantSessionDtoToJSON(value['data']),
        'errorCode': value['errorCode'],
        'message': value['message'],
        'retryable': value['retryable'],
        'recommendedAction': value['recommendedAction'],
        'correlationId': value['correlationId'],
    };
}

